var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('b-tabs',{attrs:{"pills":"","content-class":"mt-3"}},_vm._l((_vm.tabsOptions),function(option){return _c('b-tab',{key:option.value,attrs:{"title":option.title,"active":_vm.value === option.value},on:{"click":function($event){return _vm.selectOption(option)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }